import Video from "../Components/Video";
import Membres from "../Components/Membres";
import frise from '../Assets/frise.webp';
import moodboard from '../Assets/moodboard.webp';
import marianne from '../Assets/marianne.webp';
import denis from '../Assets/denis.webp';
import pauline from '../Assets/pauline.webp';
import sophie from '../Assets/sophie.webp';
import lea from '../Assets/lea.webp';

function APropos() {
    return (
        <div className="apropos-container">
            <section className="section">
                <h2 className="section-title">Qui sommes-nous ?</h2>
                <div className="video-container">
                    <Video />
                </div>
            </section>

            <section className="section">
                <h2 className="section-title">Notre histoire</h2>
                <img className="image" src={frise} alt="frise chronologique" />
            </section>

            <section className="section" id="moodboardDiv">
                <h2 className="section-title">Nos inspirations</h2>
                <div className="content">
                    <img className="image" src={moodboard} alt="moodboard de l'association" />
                <div id="movieText">
                    <p>
                        Dans l'ordre : <em>Beetlejuice, Blues Brothers, Dark Shadows, Suspiria, Labyrinth, 
                        Jujutsu Kaisen, Play, Other Side of the Box, Cabaret (1972), Rocky Horror Picture Show, 
                        Liminal Space, Scary Movie 1, Last Night in Soho, Teddy, Soyez sympas rembobinez </em>
                    </p>
                </div>
                </div>
            </section>

            <section className="section">
                <h2 className="section-title">Notre conseil d'administration</h2>
                <div className="membres-grid">
                    <Membres membresImg={lea} membresAlt="" membresHeader="Léa" membresLastName='Dentin' membrestxt="Présidente" />
                    <Membres membresImg={pauline} membresAlt="" membresHeader="Pauline" membresLastName="Cormary" membrestxt="Trésorière" />
                    <Membres membresImg={sophie} membresAlt="" membresHeader="Sophie" membresLastName="Bartoli" membrestxt="Secrétaire" />
                    <Membres membresImg={denis} membresAlt="" membresHeader="Denis" membresLastName="Vandesteene" membrestxt="Assistant bureau" />
                    <Membres membresImg={marianne} membresAlt="" membresHeader="Marianne" membresLastName="Faure" membrestxt="Responsable Comm" />
                </div>
            </section>
        </div>
    );
}

export default APropos;